/* Tab-switching for the Collection tabs ("What's In Rotation") section.
 * All tab panels are pre-rendered on page load (each tab's products
 * already exist in the DOM, mostly `hidden`); clicking a pill just
 * shows/hides panels and updates which pill is active plus the
 * "Shop all" link's destination - no network request, so switching is
 * instant. Fine for the tab counts this section is built for. If the
 * merchant ever adds a very large number of tabs and initial page
 * weight becomes a real concern, fetching only the clicked tab's
 * products via Shopify's Section Rendering API is the documented
 * scale-out path (see decisions.md) - not needed yet, not built here.
 */
(function () {
  function initCollectionTabs(root) {
    var pills = root.querySelectorAll('[data-collection-tabs-pill]');
    var viewAllLink = root.querySelector('[data-collection-tabs-view-all]');

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var targetId = pill.getAttribute('data-target');
        var targetPanel = root.querySelector('#' + targetId);
        if (!targetPanel) return;

        pills.forEach(function (p) {
          p.classList.remove('is-active');
          p.setAttribute('aria-selected', 'false');
        });
        pill.classList.add('is-active');
        pill.setAttribute('aria-selected', 'true');

        root.querySelectorAll('.collection-tabs__panel').forEach(function (panel) {
          panel.classList.remove('is-active');
          panel.hidden = true;
        });
        targetPanel.classList.add('is-active');
        targetPanel.hidden = false;

        if (viewAllLink) {
          var url = pill.getAttribute('data-collection-url');
          if (url) viewAllLink.setAttribute('href', url);
        }

        pill.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      });
    });
  }

  document.querySelectorAll('[data-collection-tabs]').forEach(initCollectionTabs);
})();
